import { render, staticRenderFns } from "./orderRemark.vue?vue&type=template&id=d33c47e4&scoped=true"
import script from "./orderRemark.vue?vue&type=script&lang=js"
export * from "./orderRemark.vue?vue&type=script&lang=js"
import style0 from "./orderRemark.vue?vue&type=style&index=0&id=d33c47e4&prod&scoped=true&lang=css"
import style1 from "./orderRemark.vue?vue&type=style&index=1&id=d33c47e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33c47e4",
  null
  
)

export default component.exports